// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__18d_c","sendOtp":"AuthorizeToLogin_sendOtp__2zV8W"};